import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "@components/organisms/Home/Home";
import Receipts from "@components/organisms/Receipts/Receipts";
import CreateReceipt from "@components/organisms/CreateReceipt/CreateReceipt";
import ReceiptProducts from "@components/organisms/ReceiptProducts/ReceiptProducts";
import ReceiptReturns from "@components/organisms/ReceiptReturns/ReceiptReturns";
import ReceiptDetail from "@components/organisms/ReceiptDetail/ReceiptDetail";
import Remisiones from "@components/organisms/Remisiones/Remisiones";
import CreateRemision from "@components/organisms/CreateRemision/CreateRemision";
import RemisionProducts from "@components/organisms/RemisionProducts/RemisionProducts";
import RemisionReturns from "@components/organisms/RemisionReturns/RemisionReturns";
import RemisionDetail from "@components/organisms/RemisionDetail/RemisionDetail";
import RemisionDispatchMovements from "@components/organisms/RemisionDispatchMovements/RemisionDispatchMovements";
import RemisionStateHistory from "@components/organisms/RemisionStateHistory/RemisionStateHistory";
import Clients from "@components/organisms/Clients/Clients";
import CreateClient from "@components/organisms/CreateClient/CreateClient";
import EditClient from "@components/organisms/EditClient/EditClient";
import ClientDetail from "@components/organisms/ClientDetail/ClientDetail";
import Products from "@components/organisms/Products/Products";
import CreateProduct from "@components/organisms/CreateProduct/CreateProduct";
import EditProduct from "@components/organisms/EditProduct/EditProduct";
import ProductDetail from "@components/organisms/ProductDetail/ProductDetail";
import MyAccount from "@components/organisms/MyAccount/MyAccount";
import MyRoute from "../AppRoutes/MyRoute";
import MainLayout from "../templates/MainLayout";
const MainPage: React.FC = () => {
  return <Routes>
      <Route path="" element={<MyRoute element={<MainLayout />} isPublic={false} />}>
        <Route path="/" element={<Navigate to="/inicio" />} />
        <Route path="/inicio" element={<Home />} />
        <Route path="/recibos" element={<Receipts />} />
        <Route path="/recibos/crear" element={<CreateReceipt />} />
        <Route path="/recibos/:id/productos" element={<ReceiptProducts />} />
        <Route path="/recibos/:id/devoluciones" element={<ReceiptReturns />} />
        <Route path="/recibos/:id" element={<ReceiptDetail />} />
        <Route path="/remisiones" element={<Remisiones />} />
        <Route path="/remisiones/crear" element={<CreateRemision />} />
        <Route path="/remisiones/:id/productos" element={<RemisionProducts />} />
        <Route path="/remisiones/:id/devoluciones" element={<RemisionReturns />} />
        <Route path="/remisiones/:id/despachos/:detailId" element={<RemisionDispatchMovements />} />
        <Route path="/remisiones/:id/estados" element={<RemisionStateHistory />} />
        <Route path="/remisiones/:id" element={<RemisionDetail />} />
        <Route path="/clientes" element={<Clients />} />
        <Route path="/clientes/crear" element={<CreateClient />} />
        <Route path="/clientes/editar/:id" element={<EditClient />} />
        <Route path="/clientes/:id" element={<ClientDetail />} />
        <Route path="/productos" element={<Products />} />
        <Route path="/productos/crear" element={<CreateProduct />} />
        <Route path="/productos/editar/:id" element={<EditProduct />} />
        <Route path="/productos/:id" element={<ProductDetail />} />
        <Route path="/mi-cuenta" element={<MyAccount />} />
      </Route>
    </Routes>;
};
export default MainPage;